export default {
  state: {
    info: ""
  },
  mutations: {
    //改变语言
    changeInfo(state, content) {
      state.info = content;
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/state.js